const generateUniqueId = () => {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, "0");
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const year = String(currentDate.getFullYear()).slice(-2);
  const randomStrings = Array.from({ length: 4 }, () =>
    Math.random().toString(36).substring(2, 3)
  ).join("");
  const id = `${day}-${month}-${year}-${randomStrings}`;
  return id;
};

export default generateUniqueId;
